import { useState, useEffect } from "react";
import { fetchMyPage } from "../api/my-page/fetch-api";
import { getMyPageSetting } from "../api/setting/pageApi";
import { useDispatch } from "react-redux";
import { setPageSettings } from "../store/actions/pageActions";
import { errorStatusHandle } from "../utils";
import {
  clearComponentLoading,
  clearPageLoading,
  resetAlert,
  setComponentLoading,
  setPageLoading,
  clearButtonProcessing,
  setButtonProcessing,
} from "../store/actions";
import _ from "lodash";

export const useMyPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [allNotifications, setAllNotifications] = useState([]);
  const [approvalNotifications, setApprovalNotifications] = useState([]);
  const [supportValues, setSupportValues] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setComponentLoading("mypage"));
    dispatch(resetAlert());
    dispatch(setButtonProcessing("btn-mypage-filter"));
    fetchMyPage()
      .then((res) => {
        setAllNotifications(res.data.notifications);
        setNotifications(res.data.notifications.slice(0, 7));
        setApprovalNotifications(res.data.approval_notifications);
        setSupportValues(getSupportValues(res.data.approval_notifications));
        dispatch(clearButtonProcessing("btn-mypage-filter"));
        dispatch(clearPageLoading());
        dispatch(clearComponentLoading("mypage"));
      })
      .catch((e) => {
        dispatch(clearComponentLoading("mypage"));
        dispatch(clearButtonProcessing("btn-mypage-filter"));
        errorStatusHandle(e.response);
      });
  }, [dispatch]);

  const getSupportValues = (data) => {
    if (_.isEmpty(data)) {
      return {};
    }
    const maxDatetime = data.reduce((max, current) => {
      return new Date(current.end_datetime) > new Date(max)
        ? current.end_datetime
        : max;
    }, data[0].end_datetime);
    const status = data.some((obj) => obj.status === 1);
    return {
      last_datetime: maxDatetime,
      status: status,
    };
  };

  useEffect(() => {
    dispatch(setPageLoading());
    getMyPageSetting()
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
      })
      .catch((e) => {
        errorStatusHandle(e.response);
      });
  }, [dispatch]);
  return {
    notifications,
    setNotifications,
    allNotifications,
    approvalNotifications,
    supportValues,
  };
};
